import { displayVersion } from "../lib/release";
import type { ReleaseState } from "../hooks/use-release";

type FooterProps = {
  release: ReleaseState;
  onContactClick: () => void;
};

export function Footer({ release, onContactClick }: FooterProps) {
  const versionSegment =
    release.status === "ready" && release.manifest
      ? `v ${displayVersion(release.manifest.version)} · `
      : "";
  return (
    <footer
      style={{
        borderTop: "1px solid var(--line)",
        padding: "40px 40px 60px",
        background: "var(--bg-subtle)",
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1.5fr 1fr",
          gap: 40,
        }}
      >
        <div>
          <img src="/katenaria-logo.svg" alt="Katenaria" width={80} />
          <p style={{ color: "var(--ink-3)", fontSize: 13, marginTop: 14, maxWidth: 280 }}>
            Native, deterministic runtimes for industrial data. Built for the control engineers who
            operate them.
          </p>
        </div>
        <div>
          <div className="eyebrow" style={{ marginBottom: 12 }}>
            Company
          </div>
          <div style={{ display: "grid", gap: 8, fontSize: 14 }}>
            <a href="https://katenaria.com/" target="_blank" rel="noreferrer" style={{ color: "var(--ink-2)", textDecoration: "none" }}>
              Katenaria
            </a>
            <a href="https://github.com/rtbot-dev" target="_blank" rel="noreferrer" style={{ color: "var(--ink-2)", textDecoration: "none" }}>
              GitHub
            </a>
            <button
              onClick={onContactClick}
              style={{ background: "none", border: "none", cursor: "pointer", color: "var(--ink-2)", textDecoration: "none", fontSize: 14, padding: 0, textAlign: "left" }}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
      <div
        style={{
          maxWidth: 1200,
          margin: "40px auto 0",
          borderTop: "1px solid var(--line)",
          paddingTop: 20,
          display: "flex",
          gap: 20,
          justifyContent: "space-between",
          fontSize: 12,
          color: "var(--ink-4)",
        }}
        className="mono"
      >
        <span>© 2026 Katenaria, Inc.</span>
        <span title={release.manifest?.version}>
          {versionSegment}signed · no telemetry
        </span>
      </div>
    </footer>
  );
}
